///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { UserAuthorities } from '../../services/user/user-authorities';
import { E2eTestUtils } from '../../../testing/e2e-test-utils';
import { Store } from '@ngrx/store';
import { selectCurrentCustomer } from '../store/customerAccordionStore/accordion.selectors';
import { DialogAction } from '../../dialog-manager/dialog-action-enum';
import { CustomerDTO } from '../../generated/shared-types.model';

@Component({
    selector: 'winde-customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['customer-details.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthCustomerDetailsComponent {
    public readonly tooltipsAreDisabled = E2eTestUtils.isTooltipsDisabled();

    @Input() baseUrl: string;
    userAuthorities = UserAuthorities;
    public action = DialogAction;

    selectedCustomer$ = this.store.select(selectCurrentCustomer);

    constructor(private readonly store: Store) {}

    getChildCompaniesNames(selectedCustomer: CustomerDTO) {
        return selectedCustomer.childCompanies.map((value) => value.name).join(', ');
    }
}
